/**
 * Env
 *
 */
const configMap = {
  '6000': '4000',
  '6001': '4000',
  '6002': '4002',
  '6008': '4008',
  '6009': '4009',
  '6010': '4010',
  '6011': '4011',
  '6013': '4013',
  '6016': '4016',
  '6017': '4017',
  '6018': '4018',
  '6019': '4019',
}

export const realTimePrefix = '/proveedores/app'
export const servingFromRealTime = window.location.pathname.startsWith(realTimePrefix)
export const inDev = process.env.NODE_ENV === 'development'
export const inProduction = !inDev
const env = window.appEnv
const web_port = window.location.port.toString()

if (inProduction && !configMap[web_port] && !env && !env.api) {
  alert('No se encontró configuración de acceso a la api')
}

export const apiDevHost = inDev ?
  (
    window.location.hostname !== 'localhost' ?
      window.location.hostname :
      'localhost:4003'
  ) :
  (
    env && env.api
      ? env.api
      : window.location.hostname + ':' + configMap[web_port]
  )

export const apiHost = env && env.api
  ? env.api
  : apiDevHost
